import * as api from '../services/API';
import { actions } from '../ducks/Communities';
import onError from './Error';
import { Dispatch } from 'redux';

export const fetchCommunities = () => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.fetchCommunitiesRequest());

    try {
      const communities = await api.fetchCommunities();

      return dispatch(actions.fetchCommunitiesSuccess({ communities }));
    } catch (error) {
      return onError({ error, dispatch, action: actions.fetchCommunitiesError({ error }) });
    }
  };
};
